import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08638aec"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]

import AccountSvg from '@/assets/images/Svgs/AccountSvg.vue';
import HideSvg from '@/assets/images/Svgs/HideSvg.vue';
import ImageModeSvg from '@/assets/images/Svgs/ImageModeSvg.vue';
import LogoutSvg from '@/assets/images/Svgs/LogoutSvg.vue';
import OpenSvg from '@/assets/images/Svgs/OpenSvg.vue';
import useCommonStore from '@/store/storeCommon';
import useMemberStore from '@/store/storeMember';


export default /*#__PURE__*/_defineComponent({
  __name: 'IconButtons',
  setup(__props) {

const {
  hideLeftPanel,
  showLeftPanel,
  showAccountToggle,
  imageModeToggle,
  disabledQualification,
  showPanel,
} = useCommonStore();
const { accessedMemberInfo, accessLogout } = useMemberStore();

/**
 * 로그아웃 기능을 실행합니다.
 */
const submitLogout = (): void => {
  accessLogout();

  if (!showPanel.isLeftPanel) {
    showLeftPanel();
  }

  if (showPanel.isEditPassword) {
    showPanel.isEditPassword = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["icon_buttons", [ !_unref(showPanel).isLeftPanel ? 'vertical' : 'horizon' ]])
  }, [
    (_unref(accessedMemberInfo).name)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_unref(showPanel).isLeftPanel)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: _normalizeClass({ 'account_btn' : _unref(showPanel).isAccountInfo }),
                disabled: _unref(disabledQualification)(),
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(showAccountToggle) && _unref(showAccountToggle)(...args)))
              }, [
                _createElementVNode("span", null, [
                  _createVNode(AccountSvg)
                ]),
                _createTextVNode(" ACCOUNT ")
              ], 10, _hoisted_1))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            type: "button",
            disabled: _unref(disabledQualification)(),
            onClick: submitLogout
          }, [
            _createElementVNode("span", null, [
              _createVNode(LogoutSvg)
            ]),
            _createTextVNode(" LOGOUT ")
          ], 8, _hoisted_2)
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      type: "button",
      disabled: _unref(disabledQualification)(),
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(imageModeToggle) && _unref(imageModeToggle)(...args)))
    }, [
      _createElementVNode("span", null, [
        _createVNode(ImageModeSvg)
      ]),
      _createTextVNode(" IMAGE MODE ")
    ], 8, _hoisted_3),
    (_unref(showPanel).isLeftPanel)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          type: "button",
          disabled: _unref(disabledQualification)(),
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(hideLeftPanel) && _unref(hideLeftPanel)(...args)))
        }, [
          _createElementVNode("span", null, [
            _createVNode(HideSvg)
          ]),
          _createTextVNode(" HIDE ")
        ], 8, _hoisted_4))
      : (_openBlock(), _createElementBlock("button", {
          key: 2,
          type: "button",
          disabled: _unref(disabledQualification)(),
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(showLeftPanel) && _unref(showLeftPanel)(...args)))
        }, [
          _createElementVNode("span", null, [
            _createVNode(OpenSvg)
          ]),
          _createTextVNode(" OPEN ")
        ], 8, _hoisted_5))
  ], 2))
}
}

})